import { ApprovedVendorsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

export const approvedVendorsBaseKey = ["approved-vendors"] as const

export const approvedVendorsListKey = (
  params: Parameters<typeof ApprovedVendorsService.listApprovedVendors>[0],
) => [...approvedVendorsBaseKey, params] as const

export const approvedVendorsQuery = makeQuery({
  serviceCall: ApprovedVendorsService.listApprovedVendors,
  queryKey: approvedVendorsListKey,
})

export const approvedVendorKey = (vendor_id: string) =>
  [...approvedVendorsBaseKey, vendor_id] as const

export const approvedVendorQuery = makeQuery({
  serviceCall: ApprovedVendorsService.get,
  queryKey: ({ vendor_id }) => approvedVendorKey(vendor_id),
})

export const useCreateApprovedVendorMutation = makeAxiosMutation({
  serviceCall: ApprovedVendorsService.create,
  invalidates: () => [approvedVendorsBaseKey],
})

export const useUpdateApprovedVendorMutation = makeAxiosMutation({
  serviceCall: ApprovedVendorsService.update,
  invalidates: () => [approvedVendorsBaseKey],
})

export const useDeleteApprovedVendorsMutation = makeAxiosMutation({
  serviceCall: ApprovedVendorsService.deleteMany,
  invalidates: () => [approvedVendorsBaseKey],
})

export const useArchiveApprovedVendorMutation = makeAxiosMutation({
  serviceCall: ApprovedVendorsService.archive,
  invalidates: () => [approvedVendorsBaseKey],
})

export const useRestoreApprovedVendorMutation = makeAxiosMutation({
  serviceCall: ApprovedVendorsService.restore,
  invalidates: () => [approvedVendorsBaseKey],
})

export const useDeleteApprovedVendorMutation = makeAxiosMutation({
  serviceCall: ApprovedVendorsService.delete,
  invalidates: () => [approvedVendorsBaseKey],
})
